// extracted by mini-css-extract-plugin
export default {"topic":"create-event_topic__sP9Su","keyWords":"create-event_keyWords__-dJqJ"};